import cxs from 'cxs';
import { FONT_SIZES } from '../../../common/styles/vars';

export const TITLE_WRAPPER = cxs({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '20px 0px',
  cursor: 'pointer'
});

export const TITLE = cxs({
  margin: 0
});

export const ACCORDION = cxs({
  width: '100%',
  border: 'none',
  textAlign: 'left',
  outline: 'none',
  fontSize: FONT_SIZES.default
});

export const PANEL = (maxHeight) => cxs({
  maxHeight,
  overflow: 'hidden',
  transition: 'max-height 0.3s ease-out'
});